export const getCliente = (state) => {
   return state.cliente;
};
